import { ReactComponent as SocialMediaSidebarSvg } from "../../assets/images/svgs/socialMediaSidebar.svg";

const SocialMediaSidebarIcon = ({ className = "", ...props }) => {
  return (
    <SocialMediaSidebarSvg
      className={className}
      focusable="false"
      aria-hidden="true"
      {...props}
    />
  );
};

export default SocialMediaSidebarIcon;
